export const API_NAME = "recipes";
export const ROUTE_NAME = "recipes";
export const COMPONENT_NAMES = ["recipes", "recipes"];
